// extracted by mini-css-extract-plugin
export default {"button":"Ll-z","reviewSort":"Ml-z"};